// Croqui: `components/TwoLine.tsx`.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { Mono } from './mono.tsx';

/** Célula de duas linhas: principal 13/500 e secundária 11 muted (ou mono quando é id/data). */
export function TwoLine({
  primary,
  secondary,
  mono = false,
  className,
}: {
  primary: ReactNode;
  secondary?: ReactNode;
  mono?: boolean;
  className?: string;
}) {
  return (
    <div className={cn('min-w-0 leading-tight', className)}>
      <div className="truncate font-medium">{primary}</div>
      {secondary !== undefined &&
        (mono ? (
          <Mono size={10}>{secondary}</Mono>
        ) : (
          <div className="truncate text-11 text-muted">{secondary}</div>
        ))}
    </div>
  );
}
